import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './index.css';
import SignIn from './Signin';
import Signup from './Signup';
import HafLanding from './HafLanding';
import MealDetail from './MealDetail';
import VolunteerRegistration from './VolunteerRegistration';
import TawkChat from './TawkChat';
import Home from './Home';
import BusinessInfo from './BusinessInfo';
import AddOrder from './AddOrder';
import EditOrder from './EditOrder';
import Orders from './Order'; // Make sure to import the Orders component
import { GlobalProvider } from './GlobalContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import reportWebVitals from './reportWebVitals';
import Invoice from './Invoice';
import TempTracker from './TempTracker';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading, null = no user

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser || null);
    });
    return () => unsub();
  }, []);

  if (user === undefined) return null; // loading state
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const SessionManager = () => {
  const navigate = useNavigate();
  const auth = getAuth();

  const signOutAndRedirect = useCallback(async () => {
    try {
      await signOut(auth);
    } catch (e) {
      console.error('Error during auto sign-out', e);
    } finally {
      navigate('/login', { replace: true });
    }
  }, [auth, navigate]);

  useEffect(() => {
    let timer = null;
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(signOutAndRedirect, 5 * 60 * 1000); // 5 minutes
    };

    const events = ['click', 'keydown', 'mousemove', 'touchstart'];
    events.forEach((evt) => window.addEventListener(evt, resetTimer));
    resetTimer();

    return () => {
      if (timer) clearTimeout(timer);
      events.forEach((evt) => window.removeEventListener(evt, resetTimer));
    };
  }, [signOutAndRedirect]);


  return null;
};

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} useEnterprise>
    <GlobalProvider>
      <Router>
        <SessionManager />
        <TawkChat />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/staging" element={<HafLanding />} />
          <Route path="/volunteer" element={<VolunteerRegistration />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/business-info" element={<ProtectedRoute><BusinessInfo /></ProtectedRoute>} />
          <Route path="/add-order" element={<ProtectedRoute><AddOrder /></ProtectedRoute>} />
          <Route path="/edit-order" element={<ProtectedRoute><EditOrder /></ProtectedRoute>} />
          <Route path='/orders' element={<ProtectedRoute><Orders/></ProtectedRoute>}/>
          <Route path='/Invoice' element={<ProtectedRoute><Invoice/></ProtectedRoute>}/>
          <Route path='/TempTracker' element={<ProtectedRoute><TempTracker/></ProtectedRoute>}/>
          <Route path='/meal/:slug' element={<MealDetail />} />
        </Routes>
      </Router>
    </GlobalProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
